module.exports = __webpack_public_path__ + "easeInRight.gif";